var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header pt-8 sm:pt-12 lg:pt-16"},[_c('h1',{staticClass:"heading-1 text-center lg:w-4/5 xl:w-3/5 lg:mx-auto"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.subtitle)?_c('div',{staticClass:"text-center mt-2 text-sm sm:text-base lg:w-3/5 lg:mx-auto",domProps:{"innerHTML":_vm._s(_vm.subtitle)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }